// 業務やパターン、カテゴリなどの
type ShiftCategoricalItem = {
  id: string;
  disabled: boolean;
  order: number;
};

export const compareShiftCategoricalItem = (a: ShiftCategoricalItem, b: ShiftCategoricalItem) => {
  if (a.disabled) {
    if (b.disabled) {
      // 両方不使用ならidの昇順
      return a.id.localeCompare(b.id);
    }
    // 不使用が後ろ
    return 1;
  }
  // 使用しているものが先
  if (b.disabled) {
    return -1;
  }
  // 両方使用ならorderの昇順
  const result = a.order - b.order;
  // orderが同じならidの昇順
  return result === 0 ? a.id.localeCompare(b.id) : a.order - b.order;
};
